import { useEffect, useState } from "react";
import { Plus, Trash2, BookOpen } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function DictionaryPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ term: "", replacement: "", note: "" });

  const load = async () => { const { data } = await api.get("/dictionary"); setItems(data); };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!form.term || !form.replacement) return;
    const { data } = await api.post("/dictionary", form);
    setItems([data, ...items]);
    setForm({ term: "", replacement: "", note: "" });
    toast.success("Added to dictionary");
  };
  const remove = async (id) => { await api.delete(`/dictionary/${id}`); setItems(items.filter((i) => i.id !== id)); };

  return (
    <div className="px-5 lg:px-10 py-8 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-brand-navy">Dictionary</h1>
      <p className="text-sm text-brand-muted mt-1">Teach DraftVoice your names, brands, and technical words.</p>

      <form onSubmit={add} className="mt-6 bg-white rounded-2xl border border-brand-borderc p-5 grid md:grid-cols-4 gap-3">
        <input data-testid="dict-term-input" required value={form.term} onChange={(e) => setForm({ ...form, term: e.target.value })} placeholder="Term (e.g. Praveen)" className="md:col-span-1 px-3 py-2.5 rounded-xl border border-brand-borderc bg-white text-sm focus:border-brand-purple outline-none" />
        <input data-testid="dict-replacement-input" required value={form.replacement} onChange={(e) => setForm({ ...form, replacement: e.target.value })} placeholder="Replacement (e.g. Praveen K.)" className="md:col-span-1 px-3 py-2.5 rounded-xl border border-brand-borderc bg-white text-sm focus:border-brand-purple outline-none" />
        <input value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} placeholder="Note (optional)" className="md:col-span-1 px-3 py-2.5 rounded-xl border border-brand-borderc bg-white text-sm focus:border-brand-purple outline-none" />
        <button data-testid="dict-add-btn" className="btn-primary-gradient rounded-full font-semibold inline-flex items-center justify-center gap-1"><Plus className="w-4 h-4" />Add</button>
      </form>

      {items.length === 0 ? (
        <div className="mt-10 text-center py-12 bg-white rounded-3xl border border-brand-borderc">
          <BookOpen className="w-10 h-10 mx-auto text-brand-purple" />
          <p className="mt-3 text-brand-muted">Your dictionary is empty.</p>
        </div>
      ) : (
        <div className="mt-6 space-y-2">
          {items.map((i) => (
            <div key={i.id} className="bg-white rounded-xl border border-brand-borderc px-4 py-3 flex items-center justify-between">
              <div>
                <span className="font-semibold text-brand-navy">{i.term}</span>
                <span className="mx-2 text-brand-muted">→</span>
                <span className="text-brand-text">{i.replacement}</span>
                {i.note && <span className="ml-3 text-xs text-brand-muted">· {i.note}</span>}
              </div>
              <button onClick={() => remove(i.id)} className="p-1.5 text-red-500 hover:bg-red-50 rounded-lg"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
